module.exports = __webpack_public_path__ + "static/media/test10_3.e6924007.png";